import { useStrings } from "@1js/localization-components";
import { PromptCommand } from "@1js/pl-card-components";
import { Button, makeStyles, Tooltip } from "@fluentui/react-components";
import { LinkDismissRegular } from "@fluentui/react-icons";
import * as React from "react";
import type { LinkedPrompt } from "../../services/prompt-client.web";
import { ConfirmationDialogStopSharing } from "./ManageSharedPrompts.strings";

type SharedPromptProps = {
  linkedPrompt: LinkedPrompt;
  onDeletePrompt: (prompt: LinkedPrompt) => void;
};

const useStyles = makeStyles({
  main: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-end",
    gap: "24px",
  },
  textWrapper: {
    display: "flex",
    padding: "3px 0px",
    justifyContent: "center",
    alignItems: "center",
    flex: "1 0 0",
    alignSelf: "stretch",
    "@media (max-width: 540px)": {
      height: "40px",
    },
  },
  textParent: {
    alignItems: "center",
    paddingBottom: "2px",
    flex: "1 0 0",
    alignSelf: "stretch",
    height: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    "@media (max-width: 540px)": {
      alignItems: "flex-start",
    },
  },

  buttonGroup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    height: "40px",
    padding: "0px 24px",
    "@media (max-width: 540px)": {
      padding: "0px 0px",
    },
  },
});

export const SharedPrompt: React.FC<SharedPromptProps> = ({
  linkedPrompt,
  onDeletePrompt,
}) => {
  const styles = useStyles();
  const strings = useStrings({ ConfirmationDialogStopSharing });

  const handleButtonClick = () => {
    onDeletePrompt(linkedPrompt);
  };

  return (
    <div className={styles.main}>
      <div className={styles.textWrapper}>
        <div className={styles.textParent}>
          <PromptCommand
            command={linkedPrompt.DisplayText}
            isTooltipEnabled={true}
          />
        </div>
      </div>
      <div className={styles.buttonGroup}>
        <Tooltip
          content={strings.ConfirmationDialogStopSharing()}
          relationship={"label"}
        >
          <Button
            onClick={handleButtonClick}
            appearance={"transparent"}
            icon={<LinkDismissRegular />}
            data-testid={"delete-prompt-button"}
            aria-label={
              linkedPrompt.DisplayText +
              " " +
              strings.ConfirmationDialogStopSharing()
            }
          />
        </Tooltip>
      </div>
    </div>
  );
};
